import React, { useState } from "react";
import CustomButton from "../../components/common/CustomButton";

const TeamInfoSidebar = ({
  teamInfo,
  setTeamName,
  teamName,
  handleUpdate,
  loading,
}) => {
  const [isEditing, setIsEditing] = useState(false);

  const roleWiseMembers = teamInfo?.roleWiseMembers || {};

  // role-wise colors for flexibility
  const roleColors = {
    Members: "green",
    Telecaller: "green",
    BOD: "purple",
    MD: "orange",
  };

  return (
    <div>
      {/* Team Name Section */}
      <div className="bg-gradient-to-r rounded-lg p-4 border border-blue-100">
        <div className="flex items-center justify-between mb-3">
          <label className="text-sm font-semibold text-gray-700 flex items-center gap-2">
            Team Name
          </label>
        </div>
        <div className="space-y-3">
          <input
            type="text"
            maxLength={50}
            value={teamName}
            onChange={(e) => setTeamName(e.target.value)}
            className="w-full px-3 py-2 rounded-[10px] input-focus"
            placeholder="Enter team name"
            autoFocus
          />
        </div>
      </div>

      {/* Dynamic Role Sections */}
     <div className="h-[500px] overflow-y-auto mt-4 space-y-4">
     {Object.entries(roleWiseMembers).map(([role, members], idx) => {
        const color = roleColors[role] || "gray"; // fallback color
        return (
          <div
            key={idx}
            className={`mt-3 rounded-lg p-4 border border-${color}-100`}
          >
            <div className="flex items-center gap-2 mb-3">
              <h3 className="font-semibold text-gray-700">{role}</h3>
              <span
                className={`ml-auto bg-${color}-100 text-${color}-800 px-2 py-1 rounded-full text-xs font-medium`}
              >
                {members.length}
              </span>
            </div>

            <div className="bg-white rounded-md p-3 max-h-32 overflow-y-auto">
              {members.length > 0 ? (
                <ul className="space-y-2">
                  {members.map((member, index) => (
                    <li
                      key={index}
                      className="flex items-center gap-2 text-gray-700"
                    >
                      <span
                        className={`w-2 h-2 bg-${color}-400 rounded-full`}
                      ></span>
                      {member || `Unnamed ${role}`}
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="text-gray-500 text-center py-2 italic">
                  No {role.toLowerCase()} added yet
                </div>
              )}
            </div>
          </div>
        );
      })}

     </div>
      {/* Update Button */}
      <div className="pt-4 border-t text-center flex justify-center border-gray-100">
        <CustomButton
          label="Update Team"
          isDisabled={loading}
          onClick={() => handleUpdate(teamInfo?.id, teamName)}
          className="w-full flex items-center justify-center"
        />
      </div>
    </div>
  );
};

export default TeamInfoSidebar;
